import { Link } from 'react-router-dom';

export default function Footer() {
  return (
    <footer className="bg-foreground-900 text-foreground-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-10">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                <i className="ri-play-fill text-lg text-white"></i>
              </div>
              <span className="font-heading text-xl font-bold text-white">51动漫网</span>
            </div>
            <p className="text-foreground-400 text-sm leading-relaxed">
              51动漫网提供海量日漫、韩漫、国漫在线免费观看服务，支持高清全集追更与下拉式阅读，致力于为广大动漫爱好者打造极致的追漫体验。
            </p>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4 text-sm">快速导航</h4>
            <ul className="space-y-3">
              <li><Link to="/" className="text-foreground-400 hover:text-primary-400 text-sm transition-colors duration-200 cursor-pointer">首页</Link></li>
              <li><Link to="/category/日漫" className="text-foreground-400 hover:text-primary-400 text-sm transition-colors duration-200 cursor-pointer">日漫专区</Link></li>
              <li><Link to="/category/韩漫" className="text-foreground-400 hover:text-primary-400 text-sm transition-colors duration-200 cursor-pointer">韩漫专区</Link></li>
              <li><Link to="/category/国漫" className="text-foreground-400 hover:text-primary-400 text-sm transition-colors duration-200 cursor-pointer">国漫专区</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4 text-sm">热门推荐</h4>
            <ul className="space-y-3">
              <li><Link to="/anime/kimetsu-no-yaiba" className="text-foreground-400 hover:text-primary-400 text-sm transition-colors duration-200 cursor-pointer">鬼灭之刃</Link></li>
              <li><Link to="/anime/solo-leveling" className="text-foreground-400 hover:text-primary-400 text-sm transition-colors duration-200 cursor-pointer">我独自升级</Link></li>
              <li><Link to="/anime/jujutsu-kaisen" className="text-foreground-400 hover:text-primary-400 text-sm transition-colors duration-200 cursor-pointer">咒术回战</Link></li>
              <li><Link to="/anime/one-piece" className="text-foreground-400 hover:text-primary-400 text-sm transition-colors duration-200 cursor-pointer">海贼王</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4 text-sm">关于我们</h4>
            <ul className="space-y-3">
              <li><Link to="/about" className="text-foreground-400 hover:text-primary-400 text-sm transition-colors duration-200 cursor-pointer">品牌介绍</Link></li>
              <li><a href="#" className="text-foreground-400 hover:text-primary-400 text-sm transition-colors duration-200">用户协议</a></li>
              <li><a href="#" className="text-foreground-400 hover:text-primary-400 text-sm transition-colors duration-200">隐私政策</a></li>
              <li><a href="#" className="text-foreground-400 hover:text-primary-400 text-sm transition-colors duration-200">免责声明</a></li>
            </ul>
            <div className="flex items-center gap-3 mt-5">
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-800 hover:bg-primary-500 text-foreground-300 hover:text-white transition-all duration-200 cursor-pointer" aria-label="微博"><i className="ri-weibo-line text-base"></i></a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-800 hover:bg-primary-500 text-foreground-300 hover:text-white transition-all duration-200 cursor-pointer" aria-label="微信"><i className="ri-wechat-line text-base"></i></a>
              <a href="#" className="w-9 h-9 flex items-center justify-center rounded-full bg-foreground-800 hover:bg-primary-500 text-foreground-300 hover:text-white transition-all duration-200 cursor-pointer" aria-label="B站"><i className="ri-bilibili-line text-base"></i></a>
            </div>
          </div>
        </div>

        <div className="border-t border-foreground-800 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-foreground-500 text-xs">
            &copy; 2024 51动漫网. All Rights Reserved. 本站内容仅供学习交流，请支持正版。
          </p>
          <p className="text-foreground-600 text-xs">
            51动漫网 - 您身边的动漫追更专家
          </p>
        </div>
      </div>
    </footer>
  );
}